var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import AddButton from 'components/v2/buttons/AddButton';
import DeleteButton from 'components/v2/buttons/DeleteButton';
import CargomaticInput from 'components/v2/input';
const pageTestId = 'shipper-sop-form';
export default function SopForm({ onSave, onCancel, sop: initialSOP = {} }) {
    var _a;
    const [sop, setSOP] = useState([Object.assign({}, initialSOP)]);
    const { t } = useTranslation();
    const handleCancel = () => onCancel();
    const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
    const validateErrors = (sopDocs = []) => {
        let isValid = true;
        const validatedItems = sopDocs.map((item) => {
            const errors = {};
            if (!(item === null || item === void 0 ? void 0 : item.name.trim())) {
                errors.name = { message: t('NAME_IS_REQUIRED') };
            }
            if (!(item === null || item === void 0 ? void 0 : item.link.trim())) {
                errors.link = { message: t('URL_FIELD_IS_REQUIRED') };
            }
            else if (!urlPattern.test(item === null || item === void 0 ? void 0 : item.link)) {
                errors.link = { message: t('ENTER_VALID_URL') };
            }
            if (Object.keys(errors).length) {
                item.errors = Object.assign({}, errors);
                isValid = false;
            }
            return item;
        });
        setSOP([...validatedItems]);
        return isValid;
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateErrors(sop)) {
            let payload = sop.map((item) => {
                const { errors, name, link } = item, rest = __rest(item, ["errors", "name", "link"]);
                return Object.assign(Object.assign({}, rest), { name: name.trim(), link: link.trim() });
            });
            onSave(payload);
        }
    };
    const handleFieldChange = (index, field, value) => {
        setSOP((prevSOP) => prevSOP.map((item, i) => i === index ? Object.assign(Object.assign({}, item), { [field]: value, errors: {} }) : item));
    };
    const handleDeleteSop = (index) => {
        setSOP((prevSOP) => {
            const newSOP = [...prevSOP];
            newSOP.splice(index, 1);
            if (newSOP.length === 0) {
                newSOP.push({ name: '', link: '' });
            }
            return newSOP;
        });
    };
    const handleAddSOP = () => {
        setSOP((prevSOP) => [...prevSOP, Object.assign({}, initialSOP)]);
    };
    return (React.createElement("form", { noValidate: true, onSubmit: handleSubmit, "data-testid": pageTestId },
        sop.map((item, i) => {
            var _a, _b;
            return (React.createElement("div", { key: `sop-item-${i}`, "data-testid": `${pageTestId}-item` },
                React.createElement("div", { className: "flex -mx-2" },
                    React.createElement("div", { className: "flex-1 px-2 mb-4" },
                        React.createElement(CargomaticInput, { error: (_a = item === null || item === void 0 ? void 0 : item.errors) === null || _a === void 0 ? void 0 : _a.name, id: `${pageTestId}-name-input`, type: "name", label: t('NAME'), placeholder: t('ENTER_NAME'), value: (item === null || item === void 0 ? void 0 : item.name) || '', onChange: (value) => handleFieldChange(i, 'name', value), maxLength: 40 }))),
                React.createElement("div", { className: "flex -mx-2" },
                    React.createElement("div", { className: "flex-1 px-2 mb-4" },
                        React.createElement(CargomaticInput, { error: (_b = item === null || item === void 0 ? void 0 : item.errors) === null || _b === void 0 ? void 0 : _b.link, id: `${pageTestId}-url-input`, type: "link", label: t('URL'), placeholder: t('ENTER_URL'), value: (item === null || item === void 0 ? void 0 : item.link) || '', onChange: (value) => handleFieldChange(i, 'link', value) }))),
                i > 0 && (React.createElement(DeleteButton, { className: "mt-2 flex-none", onClick: () => handleDeleteSop(i), id: `${pageTestId}-delete` })),
                React.createElement("hr", null)));
        }),
        React.createElement("div", { className: "flex justify-end mt-4 mb-4", "data-testid": `${pageTestId}-add` },
            React.createElement(AddButton, { onClick: handleAddSOP, disabled: (_a = sop[0]) === null || _a === void 0 ? void 0 : _a.id, id: `${pageTestId}-add-button` })),
        React.createElement("div", { className: "flex justify-end mb-4", "data-testid": `${pageTestId}-footer` },
            React.createElement("button", { type: "submit", className: "button button-green", "data-testid": `${pageTestId}-save-button` }, titleize(t('SAVE'))),
            React.createElement("button", { onClick: handleCancel, className: "button button-secondary", "data-testid": `${pageTestId}-cancel-button` }, t('CANCEL')))));
}
SopForm.propTypes = {
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    sop: PropTypes.array.isRequired,
};
